import { gql } from '@apollo/client';

export const CREATE_DEAL_CARVE = gql`
  mutation CreateDealCarve($input: CreateDealCarveInput!) {
    createDealCarve(input: $input) {
      id
    }
  }
`;
